import Table from "Components/UI/Table/Table";
import React, { FC, useEffect, useState } from "react";
import { reminderTableHeads, ReminderType } from "./constants";
import cn from "classnames";
import styles from "./styles/ReminderTable.module.scss";
import { useReminderTable } from "./useReminderTable";
import { toCapitalize } from "Shared/Utils/shared";
import { useAppDispatch } from "Redux/store";
import { getDashboardReminders } from "Redux/Dashboard/reducer";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";
import { LIMIT_DASHBOARD_REMINDER_PAGE } from "Shared/Constants/app";

export const ReminderTable: FC = () => {
  const { dashboardReminders, newTableBodyData, loading } = useReminderTable();
  const dispatch = useAppDispatch();
  const [selectedTypes, setSelectedTypes] = useState<ReminderType[]>([]);

  const handleTypeClick = (type: ReminderType) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  useEffect(() => {
    const params = {
      type: selectedTypes.join(","),
      offset: 0,
      limit: LIMIT_DASHBOARD_REMINDER_PAGE,
    };
    dispatch(getDashboardReminders(params));
  }, [dispatch, selectedTypes]);

  if (loading) return <SkeletonLoader height="405px" />;

  return (
    <>
      <div className={styles.buttonWrapper}>
        {dashboardReminders.reminders_count.map((state, index) => {
          const type = state?.type;
          const isActive = selectedTypes.includes(type);

          return (
            <span
              key={index}
              className={cn(
                styles[`buttonWrapper__button${index}`],
                styles.button,
                { [styles.active]: isActive }
              )}
              onClick={() => handleTypeClick(type)}
            >
              {toCapitalize(state?.type).split("_").join(" ")}:
              <span className={styles.buttonWrapper__count}>{state.count}</span>
            </span>
          );
        })}
      </div>
      <div className={styles.tableWrapper}>
        <Table data={newTableBodyData} columns={reminderTableHeads} />
      </div>
    </>
  );
};
